import AdminComponent from '@/components/dashboard/AdminComponent'

import CheckManagementSearch from '@/views/search/CheckManagementSearch'
import CheckManagementCreate from '@/views/create/CheckManagementCreate'
import CheckManagementUpdate from '@/views/update/CheckManagementUpdate'

export default {
  path: '/check-management',
  meta: { auth: true },
  component: AdminComponent,
  children: [
    { path: 'search', name: 'check-management-search', component: CheckManagementSearch },
    { path: 'create', name: 'check-management-create', component: CheckManagementCreate },
    { path: 'edit/:id', name: 'check-management-edit', component: CheckManagementUpdate, props: true }
  ]
}
